import script from "./Maintain_GenderAges.vue?vue&type=script&setup=true&lang=js"
export * from "./Maintain_GenderAges.vue?vue&type=script&setup=true&lang=js"

import "./Maintain_GenderAges.vue?vue&type=style&index=0&id=1614072a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1614072a"]])

export default __exports__